/**
 * This file is part of the "Awaken Media" project.
 *
 * (c) 2017 - CanalPlus International
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */
import React, { PureComponent } from 'react';

import {
  Wrapper,
  Select,
  StyledButton,
  Heading,
  Content,
  ButtonIcon,
  Or,
  GeolocationButtonText
} from 'shared/blocks/shops/search/components/ShopSearch.styled';
import Title from 'shared/components/presentational/Title';

export default class ShopSearch extends PureComponent {
  static defaultProps = {};

  componentDidMount() {
    this.props.resetFilters();
    this.props.fetchShops(this.props.url);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const countryCode =
      this.props.geolocation && this.props.geolocation.country_code;
    const nextCountryCode =
      nextProps.geolocation && nextProps.geolocation.country_code;
    if (countryCode !== nextCountryCode) {
      this.props.fetchCities(nextCountryCode);
    }
  }

  handleLocate = () => {
    this.props.fetchCoordinates().then(() => {
      this.handleRedirect();
    });
  };

  handleSelect = selected => {
    // redirect to store page with selected city
    this.handleRedirect(selected ? selected.value : null);
  };

  handleRedirect = selectedCity => {
    const { filterShops, pushURLHandler, redirectLink } = this.props;
    filterShops('city', selectedCity);
    if (selectedCity !== null) {
      pushURLHandler(redirectLink);
    }
  };

  render() {
    const { handleLocate } = this;
    const {
      title,
      titleHtmlTag,
      buttonGeolocation,
      filterCity,
      fetchingCoordinatesPending: locatePending,
      t
    } = this.props;

    return (
      <Wrapper>
        {title && (
          <Heading>
            <Title titleLabel={title} titleHtmlTag={titleHtmlTag} />
          </Heading>
        )}
        <Content>
          <StyledButton
            variant="primary"
            onClick={handleLocate}
            loading={locatePending}
          >
            <ButtonIcon
              width="16"
              height="16"
              xlink="/sprite.svg#cos-svg-pin"
            />
            <GeolocationButtonText>{buttonGeolocation}</GeolocationButtonText>
          </StyledButton>
          <Or>{t('blocks.shop.or')}</Or>
          {filterCity && (
            <Select
              key={`Filters_${filterCity.id}`}
              onChange={this.handleSelect}
              options={filterCity.options}
              placeholder={filterCity.name}
              value={filterCity.options.filter(
                option => option.value === filterCity.value
              )}
            />
          )}
        </Content>
      </Wrapper>
    );
  }
}
